import React from 'react';
import * as S from './HotelDetail.styles';

const DateComp = ({date, time}) => <>
  <S.BoldText>{date}, </S.BoldText> {time} IST
</>

const HotelDetail = ({details, guestDetails, checkinCheckoutDetail}) => {
  const {name, noOfGuests, noOfRooms} = guestDetails;
  return (
    <S.BookedHtlInfoInnerWrap>
      <S.BookedHtlInfoBlockWrap>
        <S.BookedHtlInfoInnerBlk>
          <S.BookedHtlNameLocWrap>
            <S.BookedHtlNameText>{details.hotel_name}</S.BookedHtlNameText>
            <S.BookedHtlLocText>{details.address}</S.BookedHtlLocText>
          </S.BookedHtlNameLocWrap>
          <S.BookedHtlStayInfoWrap>
            <S.BookedHtlDateWrap>
              <DateComp date={checkinCheckoutDetail.checkinDate} time={checkinCheckoutDetail.checkinTime} />
              <><span>- {checkinCheckoutDetail.nights} NIGHTS -</span></>
              <DateComp date={checkinCheckoutDetail.checkoutDate} time={checkinCheckoutDetail.checkoutTime} />
            </S.BookedHtlDateWrap>
            <S.BookedHtlPaxInfo>{name} | {noOfGuests} | {noOfRooms}</S.BookedHtlPaxInfo>
          </S.BookedHtlStayInfoWrap>
        </S.BookedHtlInfoInnerBlk>
        <S.BookedHtlImgBlk>
          <S.BookedHtlImg src={details.image} alt="htl" />
        </S.BookedHtlImgBlk>
      </S.BookedHtlInfoBlockWrap>
    </S.BookedHtlInfoInnerWrap>
  );
};

export default HotelDetail;
